const getters = {
	menushow: state => state.app.menushow,
	pageLoading: state => state.app.pageLoading,
	catch_components: state => state.app.catch_components,
	forbid_back: state => state.app.forbid_back,
}
export default getters
